import {AccessesBySection, UserRoleEnum} from '@/model/enums/UserRoleEnum';
import { RouteRecordRaw } from 'vue-router';
import { ShiftsRoutesEnum } from './ShiftsRoutesEnum';

const ShiftsPage            = () => import(/* webpackChunkName: "Shifts-module" */ '../pages/shifts/ShiftsPage.vue');
const ShiftPage             = () => import(/* webpackChunkName: "Shifts-module" */ '../pages/shift/ShiftPage.vue');
const ShiftData             = () => import(/* webpackChunkName: "Shifts-module" */ '../pages/shift/ShiftData/ShiftData.vue');
const ShiftTickets          = () => import(/* webpackChunkName: "Shifts-module" */ '../pages/shift/ShiftTickets/ShiftTickets.vue');
const ShiftKPI              = () => import(/* webpackChunkName: "Shifts-module" */ '../pages/shift/ShiftKPI/ShiftKPI.vue');
const ShiftTicketsHistory   = () => import(/* webpackChunkName: "Shifts-module" */ '../pages/shift/ShiftTicketsHistory/ShiftTicketsHistory.vue');

const routes:  Array<RouteRecordRaw> = [
    {
        path      : '/shifts',
        name      : ShiftsRoutesEnum.SHIFTS_LIST,
        component : ShiftsPage,
        meta: {
            tabTitle: "Work Requests",
			breadCrumbItems: [
				{label: 'Work Requests'},
			],
            roles: AccessesBySection.WRS
		}
    },
    {
        path      : '/shifts/:shiftId',
        props     : true,
        component : ShiftPage,
        meta: {
			breadCrumbItems: [
				{
                    label: 'Work Requests', 
                    to: { name: ShiftsRoutesEnum.SHIFTS_LIST} 
                },
                { label: 'Work Request details' },
			],
            roles: AccessesBySection.WRS
		},
        children: [
            {
                path      : '',
                name      : ShiftsRoutesEnum.SHIFTS_DETAIL,
                component : ShiftData,
                meta: {
                    tabTitle: 'Work Request Sheet'
                }
            },
            {
                path      : 'status',
                name      : ShiftsRoutesEnum.SHIFTS_DETAIL_TICKETS,
                component : ShiftTickets,
                meta: {
                    tabTitle: 'Shift Status'
                }
            },
            {
                path      : 'kpi',
                name      : ShiftsRoutesEnum.SHIFTS_KPI,
                component : ShiftKPI,
                meta: {
                    tabTitle: 'Shift Kpi'
                }
            },
            {
                path      : 'tickets_history',
                name      : ShiftsRoutesEnum.SHIFTS_TICKETS_HISTORY,
                component : ShiftTicketsHistory,
                meta: {
                    tabTitle: 'Shift Tickets History'
                }
            }
        ]
    },
    
];

export { routes };
export { ShiftsRoutesEnum };
